import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { LsButton } from "../../core";
import ChartOverlay from "./ChartOverlay";

const ConnectionTile = ({ title, description, IconComponent, onClick }) => (
    <Card
        onClick={onClick}
        sx={{
            width:         "100%",
            maxWidth:      325,
            minWidth:      325,
            height:        400,
            display:       "flex",
            flexDirection: "column",
            overflow:      "hidden",
            cursor:        "pointer",
            border:        "1px solid",
            borderColor:   "divider",
            boxShadow:     2,
            transition:    "transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease",

            "&:hover": {
                transform:       "scale(1.02)",
                boxShadow:       4,
                backgroundColor: "warning.main",
                color:           "warning.contrastText",
                "& .tile-actions":     { display: "flex" },
                "& .tile-icon::after": { transform: "translateY(0)" },
                "& .tile-icon svg":    { color: "#fff" },
                "& .tile-description": { color: "rgba(255,255,255,0.8)" },
            },
        }}
    >
        {/* ── Header image area ── */}
        <Box sx={{ position: "relative", height: 140, flexShrink: 0 }}>
            <ChartOverlay />

            {/* Icon badge
                - bottom: -20px  → half the badge (68/2 = 34) overlaps the card body below,
                  creating the "floating" look and preventing it from touching the navy bar
                - The ::after fill uses warning.main so the animation is actually visible        */}
            <Box
                className="tile-icon"
                sx={{
                    position:       "absolute",
                    bottom:         -20,           // FIX 2: float badge below the navy bar
                    left:           20,
                    width:          64,
                    height:         64,
                    borderRadius:   "50%",
                    bgcolor:        "background.paper",
                    border:         "2px solid",
                    borderColor:    "divider",
                    boxShadow:      2,
                    display:        "flex",
                    alignItems:     "center",
                    justifyContent: "center",
                    overflow:       "hidden",

                    // FIX 1: fill with warning.main so animation is visible
                    "&::after": {
                        content:    '""',
                        position:   "absolute",
                        inset:      0,
                        bgcolor:    "primary.main",  // was "background.paper" — invisible!
                        transform:  "translateY(100%)",
                        transition: "transform 0.3s ease",
                        zIndex:     1,
                    },

                    "& svg": {
                        fontSize:   36,
                        color:      "text.primary",
                        position:   "relative",
                        zIndex:     2,
                        transition: "color 0.3s ease",
                    },
                }}
            >
                <IconComponent />
            </Box>
        </Box>

        {/* ── Text — extra top padding to clear the overlapping badge ── */}
        <CardContent sx={{ pt: "36px", pb: 1, px: 2.5, flexGrow: 1 }}>
            <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, fontSize: "0.9375rem", mb: 0.75, lineHeight: 1.3 }}
            >
                {title}
            </Typography>
            <Typography
                className="tile-description"
                variant="body2"
                sx={{ color: "text.secondary", fontSize: "0.8125rem", lineHeight: 1.6, transition: "color 0.25s ease" }}
            >
                {description}
            </Typography>
        </CardContent>

        {/* ── Action bar — hidden until hover ── */}
        <CardActions
            className="tile-actions"
            sx={{
                display:        "none",
                px:             2,
                pb:             2,
                justifyContent: "flex-end",
            }}
        >
            <LsButton
                variant="text"
                disableRipple
                endIcon={<ArrowForwardOutlinedIcon />}
                sx={{ color: "warning.contrastText", fontWeight: 600 }}
            >
                View Details
            </LsButton>
        </CardActions>
    </Card>
);

export default ConnectionTile;